<template>
  <div>
    <div class="leaderBox" v-if="showOrhide">
		<div class="newtext">新手指引</div>
			<img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../assets/images/wdrq1.png" class="steps step1" v-if="status==1">
			<img src="../../assets/images/wdrq2.png" class="steps step2" v-if="status==2">
			<img src="../../assets/images/wdrq3.png" class="steps step3" v-if="status==3">
			<img src="../../assets/images/wdrq4.png" class="steps step4" v-if="status==4">
			<img src="../../assets/images/wdrq5.png" class="steps step5" v-if="status==5">
            <div class="stepbtn" @click="nextStep(status)">
				{{status==1?"下一步":status==2?"下一步":status==3?"下一步":status==4?"下一步":status==5?"我知道了":"我知道了"}}
			</div>
         <div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
    <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'日清'}]" />
    <div class="h-content">
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
           <!-- <el-form-item label="提报时间">
              <el-col :span="11">
                <el-date-picker
                 :clearable="false"
                  type="date"
                  placeholder="选择时间"
                  v-model="q.cdateBegin"
                  style="width: 100%;"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-col>
              <el-col class="line h-txtCenter" :span="2">至</el-col>
              <el-col :span="11">
                <el-date-picker
                 :clearable="false"
                  type="date"
                  placeholder="选择时间"
                  v-model="q.cdateEnd"
                  style="width: 100%;"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-col>
            </el-form-item>-->
              <el-form-item label="提报时间">
                  <el-col :span="22">
                      <el-date-picker
                              :clearable="false"
                              type="date"
                              placeholder="选择时间"
                              v-model="q.cdsDate"
                              style="width: 100%;"
                              value-format="yyyy-MM-dd"
                      ></el-date-picker>
                  </el-col>
              </el-form-item>
            <el-form-item class="h-formBtnOut">
              <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						  <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
            </el-form-item>
            <el-form-item class="h-formBoxR">
              <span class="h-formBoxTxt">
                综合评分：
                <span>{{pingfen}}</span>
              </span>
              <span class="h-formBoxTxt">
                当前排名：
                <span>{{paiming}}</span>
              </span>
              <el-button class="h-btn h-formBtn h-bggreen" @click="checkRank">查看总排名</el-button>
              <el-button v-auth="'myriqi'" class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"  @click="riqingtb">提报日清</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="h-table h-mrt30">
        <el-table
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          :data="tableData"
          :border="true"
          stripe
          style="width: 100%"
		  max-height="500"
        >
          <el-table-column type="selection" width="45" label="全选"></el-table-column>
          <el-table-column fixed type="index" label="#" width="40"></el-table-column>
          <el-table-column prop="cuname" label="提报人" width="80"></el-table-column>
          <el-table-column prop="cdsDate" label="日清日期" width="100"></el-table-column>
          <el-table-column prop="cdate" label="提报时间" width="160"></el-table-column>
          <el-table-column label="当日评分" width="90">
            <template slot-scope="scope">{{scope.row.adjScore?scope.row.adjScore:'暂无'}}</template>
          </el-table-column>
          <el-table-column
                  prop="adjReason"
                  label="评分原因"
                  :show-overflow-tooltip="true">
				  <template slot-scope="scope">
				  	<div style="text-align: left;">
				  		{{scope.row.adjReason}}
				  	</div>
				  </template>
          </el-table-column>
          <el-table-column prop="careTotal" label="拜访次数" width="90">
			  <template scope="scope">
			      <div style="text-align: right;">
			  		{{scope.row.careTotal}}
			  	</div>
			  </template>
		  </el-table-column>
          <el-table-column prop="resTotal" label="资源需求" width="90">
			  <template scope="scope">
			      <div style="text-align: right;">
			  		{{scope.row.resTotal}}
			  	</div>
			  </template>
		  </el-table-column>
          <el-table-column prop="orderTotal" label="信息获取"  width="90">
			  <template scope="scope">
			      <div style="text-align: right;">
			  		{{scope.row.orderTotal}}
			  	</div>
			  </template>
		  </el-table-column>
          <el-table-column
            label="操作"
            fixed="right"
			width="120"
          >
            <template slot-scope="scope">
				<div style="text-align: left;">
					<el-button
					  type="text"
					  size="small"
					  class="h-tableLink h-btn"
					  @click="checkDetail(scope.row.id)"
					>查看</el-button>
					<!-- <el-button
					v-show="scope.row.status==3"
					  type="text"
					  size="small"
					  class="h-tableLink h-btn"
					  @click="xiugai(scope.row.id)"
					>修改</el-button> -->
					<el-button
					        size="small" class="h-tableLink h-btn"
					        @click="genzongLiuch(scope.row)">
					    跟踪
					</el-button>
				</div>
              
			 <!-- <div class="l-operationBox">
			  	<span class="l-operationlist br-operation-look" title="查看" @click="checkDetail(scope.row.id)"></span>
			  	<span class="l-operationlist br-operation-spgz" title="跟踪审批" @click="genzongLiuch(scope.row)"></span>
			  </div> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
            <!-- <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export">批量导入</el-button> -->
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query" />
          </div>
        </div>
      </div>
    </div>
    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
  </div>
</template>

<script>
import ss from "../../api/SystemService";
import updownfile from '../../utils/updownfile'
export default {
  data() {
    return {
      showOrhide:false,
      status:1,
      checked:true,
      toshow:"riqing1",
      //表单
      q: {
          cdsDate:null,
          pageSize: 10,
          pageNo: 1,
          total:0,
      },
      showhistory:false,
      instid:null,
      pingfen:'暂无',
      paiming:'暂无',
      //表格
      multipleSelection: [],
      tableData: []
    };
  },
  created() {
	  this.showzhezhao()
  },
  methods: {
	  showzhezhao(){
	  	ss.salesList.toshow(this.toshow).then(rd => {
	  		console.log(rd)
	  	    if(rd == false){
	  	        this.showOrhide = false;
	  	    }else{
	  	        this.showOrhide = true;
	  	    }
	  	})
	  },
    genzongLiuch(r){
      this.instid = r.instid;
      this.showhistory = true;
    },
    //表格
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    query(){
      ss.UserCare.page(this.q).then(rd => {
        this.q.total = rd.total;
        this.tableData = rd.records;
      //  console.log("列表信息",this.tableData);
      });
    },
    xiugai(id){
      //修改
      this.$router.push({path: '/presentation', query: {rqId:id }});
    },
    myrank() {
      ss.UserCare.gradeRanking({}).then(rd => {
      //  console.log("ddssdsfd");
        if(rd.obj&&rd.obj.adjScore){
          this.pingfen=rd.obj.adjScore;
        }
        if(rd.obj&&rd.obj.orderNo){
          this.paiming=rd.obj.orderNo;
        }

      });
    },
    handleFilter() {
      this.query();
    },
    checkRank() {
      this.$router.push("/paiming");
    },
    riqingtb(){
      ss.UserCare.riqiFlag({}).then(rd => {
       // console.log("ddssdsfd",rd);
        if(rd.obj==0){
          this.$router.push("/presentation");
        }else{
          this.$message({
            message: '今日日清已提交，请勿重复提交',
            type: 'warning'
          });
        }

      });
    },
    checkDetail(id){
      //查看详情
      this.$router.push({path: '/presentation2', query: {rqId:id }});
    },
    //明细导出
			exportExcel() {
				var idlist=[];
				this.multipleSelection.forEach(element => {
					idlist.push(element.id);
				});
				this.q.ids = idlist
			//	console.log(this.q,"-----------");
                updownfile.down("/api/swyl/v1/guanhuai/userCareDailySummary/downloadExcel",this.q,"post",'data');
			},
    //重置
    rest() {
      this.q.cdsDate=null;
    },
    // 关闭新手引导页
    closeIt(){
      this.showOrhide = false;
      if(this.checked){
		 ss.salesList.toshow(this.toshow,this.checked).then(rd => {
		 	console.log(rd)
		 	this.showOrhide = false;
		 })
      }else{
		  ss.salesList.toshow(this.toshow,this.checked).then(rd => {
		  	console.log(rd)
		  	this.showOrhide = false;
		  })
	  }
    },
    nextStep(i){
      if(this.status ==1){
          this.status = 2;
      }else if(this.status ==2){
			this.status = 3;
      }else if(this.status ==3){
			this.status = 4;
      }else if(this.status ==4){
			this.status = 5;
			document.documentElement.scrollTop = 1000
      }else if(this.status ==5){
        if(this.checked){
			ss.salesList.toshow(this.toshow,this.checked).then(rd => {
				console.log(rd)
				this.showOrhide = false;
			})
        }else{
			ss.salesList.toshow(this.toshow,this.checked).then(rd => {
				console.log(rd)
				this.showOrhide = false;
			})
		}
      }
    },
  },
  mounted() {
    this.myrank();
    this.query();
  }
};
</script>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;
		}
		.steps{
			position: absolute;
			z-index: 1;
		}
		.step1{
			top: 1.75rem;
			left: 3rem;
			width: 7.05rem;
			height: 1.5rem;
		}
		.step2{
			top: 1.82rem;
			left: 14.6rem;
			width: 2.2rem;
			height: 1.7rem;
		}
		.step3{
			top: 1.82rem;
			left: 16.47rem;
			width: 1.9rem;
			height: 1.7rem;
		}
    .step4{
			top: 4.05rem;
			right: 3rem;
			width: 4.8rem;
			height: 1rem;
		}
    .step5{
			top: 7.6rem;
			left: 2.7rem;
			width: 1.65rem;
			height: 1.5rem;
		}
		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.65rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
		}
	}
</style>
